export default __webpack_public_path__ + "static/modeloavisoMODAVI16181-942025-85810-ab797d29b40c842044f34d5585feee15.pdf";